import Animation from './Animation.component';

export default Animation;
